import { render } from "./EditTypeUser.vue?vue&type=template&id=241af7b1&scoped=true"
import script from "./EditTypeUser.vue?vue&type=script&lang=js"
export * from "./EditTypeUser.vue?vue&type=script&lang=js"

import "./EditTypeUser.vue?vue&type=style&index=0&id=241af7b1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-241af7b1"]])

export default __exports__